module.exports = __webpack_public_path__ + "static/media/CircularStd-Black.a7d0eebb.woff2";